const HomeView = Barba.BaseView.extend({
    namespace: 'home',
    video: null,
    homeHeaderEl: null,

    expertisesEl: null,
    expertisesEinnerEl: null,
    expertiseWrapperEl: null,
    timeline: null,

    bounds1: null,
    bounds2: null,
    offset: null,

    onEnter() {
        this.homeHeaderEl = this.container.querySelector('.jsHomeHeader');

        initProjectBoxes(this.container);
        initScrollForMoreTriggers(this.container);
        setIframeAspectRatios(this.container);
        
        new MainMenu(this.container);
        new InViewAnimation();
        new SearchModal(this.container);

        setTimeout(_ => { setScrollAnchorPosition(this.container); }, 500)
        window.addEventListener('hashchange', _ => {
            setTimeout(_ => {
                setScrollAnchorPosition(this.container);
            }, 500);
        });

        setTimeout(_ => {
            this.initHeaderSlogan();
        }, 1000);
        
        this.animateIn();
        this.initHomeSlideshow();
        this.initHomeScrollTrigger();
    },

    initHomeScrollTrigger () {
        this.expertisesEl = this.container.querySelector('.jsHomeExpertises');
        this.expertisesInnerEl = this.expertisesEl.querySelector('.jsHomeExpertisesInner');
        this.expertiseWrapperEl = this.expertisesEl.querySelector('.jsHomeExpertisesInnerWrapper');

        this.bounds1 = this.expertisesInnerEl.getBoundingClientRect();
        this.bounds2 = this.expertiseWrapperEl.getBoundingClientRect();
        this.offset = -(this.bounds2.width - this.bounds1.width);

        ScrollTrigger.addEventListener('refreshInit', _ => {
            this.bounds1 = this.expertisesInnerEl.getBoundingClientRect();
            this.bounds2 = this.expertiseWrapperEl.getBoundingClientRect();
            this.offset = -(this.bounds2.width - this.bounds1.width);
        });

        this.timeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.expertisesEl,
                pin: true,
                start: 'top top',
                end: () => '+=' + this.bounds1.width * 2,
                scrub: true,
                pinSpacing: true,
                invalidateOnRefresh: true
            }
        })
            .to(this.expertiseWrapperEl, { x: () => {
                this.bounds1 = this.expertisesInnerEl.getBoundingClientRect();
                this.bounds2 = this.expertiseWrapperEl.getBoundingClientRect();
                this.offset = -(this.bounds2.width - this.bounds1.width);

                return this.offset;
            }, ease: Power0.easeNone })
        ;
    },

    initHomeSlideshow() {
        new HomeHeaderSlideshow(this.homeHeaderEl);
    },

    initHeaderSlogan() {
        const slogan = this.container.querySelector('.jsHeaderSlogan');
        const circle = slogan.querySelector('.jsCircleMask');

        if (circle !== null) {
            let circlePos = circle.getBoundingClientRect();
            let first = true;

            window.addEventListener('resize', _ => {
                TweenLite.set(circle, { x: 0, y: 0 });
                circlePos = circle.getBoundingClientRect();
            });

            window.addEventListener('mousemove', e => {
                const circleX = e.pageX - (circlePos.x || circlePos.left) - (circlePos.width / 2);
                const circleY = e.pageY - (circlePos.y || circlePos.top) - (circlePos.height / 2);

                if (first) TweenLite.set(circle, { x: circleX, y: circleY, opacity: 1 });
                else TweenLite.to(circle, 1, { x: circleX, y: circleY });

                first = false;
            });
        }
    },

    animateIn() {
        const slogan = this.container.querySelector('.jsHeaderSlogan');
        const scrollForMore = this.container.querySelector('.jsFirstScrollForMore');

        new TimelineMax()
            .set(slogan, { x: -10 })
            .set(scrollForMore, { y: 10 })

            .to(slogan, 1, { x: 0, opacity: 1, ease: Power2.easeOut })
            .to(scrollForMore, 1, { y: 0, opacity: 1, ease: Power2.easeOut }, '-=1')

            .add(_ => {
                slogan.classList.remove('start-hidden');
                scrollForMore.classList.remove('start-hidden');
            })
        ;
    }
});

HomeView.init();